import { useState } from 'react';
import MenuIcon from '../../assets/icons/Menu.svg';
import MobileMenu from './MobileMenu';

import './MenuMobileButton.scss';

const MenuMobileButton = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return (
    <>
      <div className="mobile-menu">
        <button className="mobile-menu__button">
          <img src={MenuIcon} alt="" onClick={() => setIsMenuOpen(true)} />
        </button>
      </div>
      {isMenuOpen && (
        <section className="mobile-menu__overlay">
          <MobileMenu setIsMenuOpen={setIsMenuOpen} />
        </section>
      )}
    </>
  );
};

export default MenuMobileButton;
